type ToastHandler = (message: string, error?: unknown) => void;

let globalHandler: ToastHandler | null = null;
const pendingErrors: Array<{ message: string; error: unknown }> = [];

export function setGlobalToastHandler(handler: ToastHandler | null) {
  globalHandler = handler;
  if (handler) {
    for (const pending of pendingErrors.splice(0)) {
      handler(pending.message, pending.error);
    }
  }
}

export function emitGlobalError(error: unknown) {
  const message = extractErrorMessage(error);
  if (!message) return;
  if (globalHandler) {
    globalHandler(message, error);
  } else if (pendingErrors.length < 50) {
    pendingErrors.push({ message, error });
  }
}

function isNetworkError(error: unknown): boolean {
  const e = error as {
    code?: string;
    request?: unknown;
    response?: unknown;
  };
  // Axios network errors: request was sent but no response received
  return (e.code === 'ERR_NETWORK' || (!!e.request && !e.response)) && !e.response;
}

function extractErrorMessage(error: unknown): string {
  if (!error) {
    return 'An unexpected error occurred';
  }

  if (typeof error === 'string') {
    return error;
  }

  // Map network-level failures to a localized offline message
  if (isNetworkError(error)) {
    return 'Sin conexión — verificá tu conexión a internet';
  }

  const httpError = error as {
    response?: {
      data?: { message?: string; error?: string };
      statusText?: string;
      status?: number;
    };
    message?: string;
  };

  if (httpError.response?.data?.message) {
    return httpError.response.data.message;
  }

  if (httpError.response?.data?.error) {
    return httpError.response.data.error;
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (httpError.message) {
    return httpError.message;
  }

  return 'An unexpected error occurred';
}
